// État client gardé en mémoire le temps d'une navigation (jamais stocké), vidé à la déconnexion
// et à tout changement de compte : rien ne passe d'une session à l'autre dans un même onglet.
export const ephemeral: {
  /** Mot de passe provisoire saisi à la connexion, pour le changement forcé. */
  provisional: string | null;
  /** Brouillon de l'assistant de création (aller-retour vers la carte). */
  draft: unknown;
} = { provisional: null, draft: null };

export function resetEphemeral() {
  ephemeral.provisional = null;
  ephemeral.draft = null;
}
